import { isURL, isEmail } from 'validator';
import { isFilled } from '@prismicio/client';
import { JSXMapSerializer } from '@prismicio/react';

import { defaultEnv } from '@preventx/prismic-services';
import { Link, LinkType, Typography, parsePhoneNumber } from '@preventx/oxygen';

const MailToText = 'mailto:';
const TelephoneText = 'tel:';

export const RichTextDefaultConfiguration: JSXMapSerializer = {
  paragraph: ({ children }) => (
    <Typography component="p">{children}</Typography>
  ),
  strong: ({ children }) => (
    <Typography component="strong">{children}</Typography>
  ),
  hyperlink: ({ children, node }) => {
    const { data } = node;

    // Purpose  : Unlikely to occur but in the event it does it'll stop a link from being
    //            rendered without the correct markup, in turn removing an accessibility
    //            and semantic markup issue due to say a missing HREF (example).
    if (!isFilled.link(data) || !data.url) {
      return <Typography component="span">{children}</Typography>;
    }

    let linkType: LinkType = 'default';

    if (!isURL(data.url)) {
      // Purpose  : If someone has already put this in then there is no benefit for
      //            doing it again
      if (
        !data.url.startsWith(MailToText) &&
        !data.url.startsWith(TelephoneText)
      ) {
        if (isEmail(data.url)) {
          linkType = 'telephone';
        } else {
          const parsedNumber = parsePhoneNumber({
            value: data.url,
            validationMessage: undefined,
            countryCode: defaultEnv.CountryCode,
          });

          linkType = parsedNumber ? 'telephone' : 'default';
        }
      }
    }

    return (
      <Link type={linkType} to={data.url} variant="link-default">
        {children}
      </Link>
    );
  },
};
